import styled from 'styled-components';
import { Button } from '../Button';
import HStack from '../HStack';
import Heading from '../Heading';
import React, { ReactNode } from 'react';

const CloseIcon = (props: any) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
      <path d="M1.41 0l-1.41 1.41.72.72 1.78 1.81-1.78 1.78-.72.69 1.41 1.44.72-.72 1.81-1.81 1.78 1.81.69.72 1.44-1.44-.72-.69-1.81-1.78 1.81-1.81.72-.72-1.44-1.41-.69.72-1.78 1.78-1.81-1.78-.72-.72z" />
    </svg>
  );
};

export interface ModalHeaderProps {
  title?: string;
  titleFontSize?: string[] | number[] | string | number;
  onClose?: () => void;
  color?: string;
  children?: ReactNode;
  closeIcon?: ReactNode;
}

export const ModalHeader = (props: ModalHeaderProps) => {
  return (
    <HStack justifyContent="space-between" mb="10px" alignItems={'center'}>
      {props.children || (
        <Heading level={4} aria-hidden={!props.title} m="0px" color={props.color} p="0px" {...(props.titleFontSize && { fontSize: props.titleFontSize })}>
          {props.title}
        </Heading>
      )}
      <StyledCloseButton onClick={props.onClose} variant="icon" p="1%" aria-hidden="true">
        {props.closeIcon || <StyledCloseIcon aria-label="Cerrar" />}
      </StyledCloseButton>
    </HStack>
  );
};

const StyledCloseIcon = styled(CloseIcon)({
  width: '1em',
  marginRight: '5px',
  opacity: 1,
  ':hover': {
    opacity: 0.5,
  },
});

const StyledCloseButton = styled(Button)({
  ':focus': {
    outline: 'none',
  },
  position: 'absolute',
  right: 0,
});
